import { render, staticRenderFns } from "./it.vue?vue&type=template&id=0d210778&scoped=true&"
import script from "./it.vue?vue&type=script&lang=js&"
export * from "./it.vue?vue&type=script&lang=js&"
import style0 from "./it.vue?vue&type=style&index=0&id=0d210778&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d210778",
  null
  
)

export default component.exports